<!--
  -  Copyright (c) Qwoach LLC 2020. All rights reserved.
  -  Unauthorized copying of this file, via any medium is strictly prohibited
  -  Proprietary and confidential
  -  Created by Artem Bogush <artem@qwoach.com> on 01/01/2019
  -->

<template>


	<div class="fill-height-container card mb-5 event-settings-root">


		<div v-if="eventType" @mouseup="clearFormValidationInternal()" class="qwoach-form expand-error">
			<!--			<div v-sticky on-stick="onSaveIsSticky" :class="{'sticked': isSaveButtonSticked}">-->
			<div>
				<div class="row mx-0 px-4">

					<div class="layout-spacer"/>

					<SaveButton @click="submitFormInternal"
								size="small"
								class="my-3 mr-2"/>

					<OptionsMenu
						ref="optionsMenu"
						v-if="!hideMenu"
						:menuItems="menuItems"
						@menuClicked="menuClicked"
						@click="onMenuItemClicked"/>
				</div>
				<hr/>
			</div>
			<el-form :model="eventType" :rules="rules" ref="mainForm" class="p-3">

				<FormTextRow
					prop="displayName"
					class="mb-3"
					tooltipPosition="title"
					:isVertical="isVerticalComputed"
					:labelMinWidth="labelMinWidth"
					title="Session Name"
					:tooltip-analytics-props="{label:'Session Name', ...this.analyticsPropsMethod()}"
					tooltipText="The name of the session that will be shown to your clients and prospects when they book a session with you."
					v-model="eventType.displayName"
					:input-debounce-delay="inputDebounceDelay"
					@change="valueChanged('Session Name')">

				</FormTextRow>

				<FormRow
					prop="displayId"
					class="mb-3"
					tooltipPosition="title"
					:isVertical="isVerticalComputed"
					:labelMinWidth="labelMinWidth"
					title="Session Link"
					:tooltip-analytics-props="{label:'Session Link', ...this.analyticsPropsMethod()}"
					tooltipText="Session Link is the unique link that you share with your invitees so they can schedule this type of session with you.">

					<div class="row m-0 align-items-center card flex-row px-3">
						<span class="text-muted">qwoach.com/{{ ownerProfile.schedulerSettings.eventTypeUserId }}/</span>
						<qw-input
							class="height__15em white-smoke mb-3 mt-3"
							placeholder="type here"
							:input-debounce-delay="inputDebounceDelay"
							@change="onLinkChanged({skipSave: true})"
							@blur="onLinkChanged({skipSave: false})"
							@keydown.native="onLinkKeyDown"
							v-model="eventType.displayId"/>
						<ToolTipView
							:tooltip-analytics-props="{label:'Open scheduling link', ...this.analyticsPropsMethod()}"
							position="top">
							<template #icon>
								<a :href="sessionFullUrlComputed" target="_blank"
								   @click="openLinkClicked"
								   class="external button-circle"
								   :class="{disabled: !eventType.displayId}"></a>
							</template>
							<span v-if="eventType.displayId">
								Live Preview This Session
							</span>
							<span v-else>
								Please type a link for this session on the left
							</span>
						</ToolTipView>
						<ToolTipView
							:tooltip-analytics-props="{label:'Copy scheduling link', ...this.analyticsPropsMethod()}"
							position="top">
							<template #icon>
								<qw-link-button
									:class="{disabled: !eventType.displayId}"
									@click="copyLink">Copy link</qw-link-button>
							</template>

							<span v-if="eventType.displayId">
								Copy scheduling link
							</span>
							<span v-else>
								Please type a link for this session on the left
							</span>
						</ToolTipView>
					</div>

				</FormRow>

				<FormNumberRow
					prop="duration"
					class="mb-3"
					contentClass="card flex-row px-3"
					tooltipPosition="title"
					:isVertical="isVerticalComputed"
					titlePostfix="minutes"
					:tooltip-analytics-props="{label:'Session Duration', ...this.analyticsPropsMethod()}"
					tooltipText="Define how long this session will be."
					:labelMinWidth="labelMinWidth"
					:formatDataInProp="formatDataInMinutes"
					:formatDataOutProp="formatDataOutMinutes"
					title="Duration"
					:input-debounce-delay="inputDebounceDelay"
					@change="onDurationChanged()"
					v-model="eventType.duration"/>


				<FormRow
					:isVertical="isVerticalComputed"
					prop="locations"
					class="mb-3"
					tooltipPosition="title"
					:labelMinWidth="labelMinWidth - 0"
					:tooltip-analytics-props="{label:'Session Location', ...this.analyticsPropsMethod()}"
					title="Session Location"
					tooltipText="Possible locations for this session - you can add multiple locations.<br/><br/> Your client will be able to choose best location when they schedule a session with you."
					v-model="eventType.displayName">

					<LocationChooser
						ref="locationChooser"
						class="card px-3"
						:analytics-props="analyticsPropsMethod()"
						@startIntegrationClicked="startIntegrationClicked"
						:locations="eventType.locations"/>

				</FormRow>

				<FormRow
					title="Session Color"
					class="py-3"
					:isVertical="isVerticalComputed"
					:labelMinWidth="labelMinWidth">

					<PaletteColorPicker
						:inline="true"
						v-model="eventType.eventColor"
						@change="valueChanged"/>

				</FormRow>
				<hr/>
				<FormEditorRow
					prop="description"
					class="my-3"
					tooltipPosition="title"
					:analytics-props="analyticsPropsMethod()"
					:isVertical="isVerticalComputed"
					:multiline="true"
					:labelMinWidth="labelMinWidth"
					:minRows="4"
					:tooltip-analytics-props="{label:'Session description', ...this.analyticsPropsMethod()}"
					title="Description"
					placeholder="Session description (optional)"
					tooltipText="Use this field to provide additional details about this session."
					:input-debounce-delay="inputDebounceDelay"
					@change="valueChanged('Session description')"
					v-model="eventType.description"/>


				<hr/>
				<!--				<div class="form-padding py-3 mt-4">Pricing</div>-->

				<FormCheckboxRow
					v-if="isOwner"
					title="Collect payments"
					v-model="eventType.paidSession"
					:isVertical="isVerticalComputed"
					tooltipPosition="title"
					tooltipText="You can collect payments for this session before your clients can confirm time with you.<br/><br/>It will bring a payment form on the session confirmation page.<br/><br/>For the Free or Prepaid Sessions, uncheck this checkbox."
					@change="valueChanged()">
					<template #postfix v-if="eventType.paidSession && hasPaymentIntegration">
						<qw-button
							size="small"
							class="ml-4"
							@click="onShowPaymentMethodsClicked">Manage Payment Methods</qw-button>
					</template>

				</FormCheckboxRow>
				<div v-if="eventType.paidSession" class="mt-2">

					<div v-if="hasPaymentIntegration">
						<FormNumberRow
							prop="price"
							title="Price"
							class="mb-3"
							tooltipPosition="title"
							:isVertical="isVerticalComputed"
							:titlePostfix="currencyItemGlobal.currencyCode"
							tooltipText="Set the price for this session - your invitees will be asked to pay before completing the booking. <br/><br/>Leaving 0 will treat this session as Free or Prepaid."
							:labelMinWidth="labelMinWidth"
							:input-debounce-delay="inputDebounceDelay"
							v-model="eventType.price"
							@change="valueChanged()"/>

						<FormTextRow
							prop="price"
							title="Payment terms"
							class="mb-3"
							:multiline="true"
							:min-rows="3"
							:input-debounce-delay="inputDebounceDelay"
							placeholder="Type any additional information for your invitees (optional)"
							tooltipPosition="title"
							:isVertical="isVerticalComputed"
							tooltipText="Use this filed to provide any important information for your invitees, for example your cancellation or reschedule policy.<br/><br/>Payment terms will appear under the price on the scheduling page and in confirmation emails."
							:labelMinWidth="labelMinWidth"
							v-model="eventType.paymentTerms"
							@change="valueChanged()"
						/>
<!--						<div class="form-padding card border-warning p-3 mt-3">-->
<!--						<span>-->
<!--						</span>-->
<!--						</div>-->
					</div>


					<div v-else class="form-padding card border-warning p-3 mt-3">
						<span>
						<a href="#" @click.prevent="onShowPaymentMethodsClicked">Click here</a> to setup payment integration before you can accept payments.
						</span>
					</div>
				</div>


			</el-form>
		</div>

		<qw-drawer
			v-if="showPaymentMethodsOptions"
			v-model="showPaymentMethodsOptions"
			custom-class="bg-app-primary"
			:modal="showDrawerAsModal"
			size="80%"
			direction="rtl">

			<PaymentMethodsView
				:paymentIntegrations="paymentIntegrations"/>
		</qw-drawer>


		<LoadingIndicator :text="progressText"
						  v-if="isDataLoading"
						  class="center-fixed"/>

		<SavingNotification ref="savingNotification"/>


		<!--		<el-button @click="showSavingIndicator">Show</el-button>-->
	</div>


</template>
<style>

</style>

<script>

import LocationChooser from "@/core/components/LocationChooser/LocationChooser"

import LoadingIndicator from "@/core/components/LoadingIndicator.vue";
import QwInput from "@/core/components/Controls/QwInput.vue";
import FormTextRow from "@/core/components/Form/FormTextRow.vue";
import FormRow from "@/core/components/Form/Base/FormRow.vue";
import FormNumberRow from "@/core/components/Form/FormNumberRow.vue";
import FormEditorRow from "@/core/components/Form/FormEditorRow.vue";
import SavingNotification from "@/core/components/Notifications/SavingNotification.vue";
import SaveButton from "@/core/components/Controls/Buttons/SaveButton.vue";
import FormCheckboxRow from "@/core/components/Form/FormCheckboxRow.vue";
import PaymentMethodsView from "@/core/modules/coach/Billing/view/PaymentIntegrations/PaymentMethodsView.vue";
import OptionsMenu from "@/core/components/Menu/OptionsMenu.vue";
import {MenuAction} from "@/core/modules/coach/Resources/Files/QwoachDrive/MenuAction";
import MenuItem from "@/core/modules/coach/Resources/Files/QwoachDrive/MenuItem";
import SessionTypeHelper from "@/core/modules/coach/Scheduler/EventTypes/Settings/SessionTypeHelper";

import BaseComponent from "@/core/components/BaseComponent.vue";
import EmailReminderItem, {
	defaultReminderBody,
	defaultReminderSubject
} from "@shared/scheduler/reminders/EmailReminderItem";
import PaymentIntegrations from "@shared/Billing/PaymentIntegrations";
import EventType from "@shared/scheduler/EventType";
import {isLinkValid} from "@/utils/helpers";
import ToolTipView from "@/core/components/Form/Base/ToolTipView.vue";

import {deleteConfirmDialog} from "@/core/components/Dialogs/dialog"
import PaletteColorPicker from "@/core/components/PaletteColorPicker.vue";
import Debouncer from "@shared/Debouncer";
import {isMobileScreen} from "@/core/screenHelper";
import TeamAssignManager from "@shared/TeamAssignManager";

export default {
	extends: BaseComponent,
	name: "EventTypeGeneralSettingsView",
	components: {
		PaletteColorPicker,
		ToolTipView,
		OptionsMenu,
		PaymentMethodsView,
		FormCheckboxRow,
		SaveButton,
		SavingNotification,
		FormEditorRow,
		FormNumberRow,
		FormRow,
		FormTextRow,
		QwInput,
		LoadingIndicator,
		LocationChooser
	},
	props: {
		paymentIntegrations: PaymentIntegrations,
		eventType: EventType,
		backRouteName: String,
		hideMenu: Boolean,
		hideToast: Boolean,
		tooltipAnalyticsProps: Object,
		validateOnEnter: Boolean,
		showDrawerAsModal: {Boolean, default: true},
	},
	watch: {
		eventType: {
			immediate: true,
			handler() {
				this.displayNameInitial = this.eventType.displayName
			}
		}
	},
	data() {
		return {
			teamAssignManager: null,
			reminderOptions: [],
			reminderOptionsDirections: [],
			inputDebounceDelay: 1000,
			displayNameInitial: null,
			showEmailNotificationPersonalization: false,
			linkChanged: false,
			showPaymentMethodsOptions: false,
			isSaveButtonSticked: false,
			isVertical: false,
			labelMinWidth: 200,
			sessionTypeHelper: null,
			rules: {
				displayName: [
					{
						required: true,
						whitespace: false,
						message: 'Please choose a name for this session type',
						trigger: 'validate'
					},
				],
				displayId: [
					{
						required: true,
						whitespace: false,
						validator: async (rule, value, callback, source, options) => {

							let error;
							if (value.length === 0) {
								error = 'Please choose a link for this session'
							} else if (!this.eventType.isCategoryProgram() && !isLinkValid(value)) {
								error = "Invalid link. Please use only lowercase 'a-z', '0-9', '-', or '_' characters."
							} else if (this.linkChanged) {
								try {
									let eventType = await this.$dataManager.apiGetEventTypePublic({
										eventTypeUserId: this.userProfile.schedulerSettings.eventTypeUserId,
										eventTypeId: value
									})
									if (eventType && (!this.eventType || eventType.id !== this.eventType.id)) {
										error = `This link is already taken. Please use a different link.`
									} else {
										this.linkChanged = false
									}
								} catch (e) {
									error = `Can't validate this link. Make sure you are connected to the internet.`
								}
							}
							if (error) {
								await this.setEventTypeNeedsSetup()
							}
							callback(error);
						},
						trigger: 'validate'
					},
				],
				rollingDays: [
					{
						validator: (rule, value, callback, source, options) => {
							let error;
							if (value.length === 0) {
								error = 'Date range is required'
							} else if (this.eventType.rollingDays < 1) {
								error = `Date range should be at least 1 day`
							}
							callback(error);
						},
						trigger: 'validate'
					},
				],
				duration: [
					{
						validator: (rule, value, callback, source, options) => {
							let error;
							if (value.length === 0) {
								error = 'Duration is required'
							} else if (this.eventType.duration > 12 * 60 * 60 * 1000) {
								error = `Duration should be less than 12 hours (${12 * 60} minutes)`
							} else if (this.eventType.duration < 5 * 60 * 1000) {
								error = `Duration should be at least 5 minutes`
							}
							callback(error);
						},
						trigger: 'validate'
					}
				],
				increments: [
					{
						validator: (rule, value, callback, source, options) => {
							console.log("value11 = ", value)
							let error;
							if (!value) {
								error = 'Increment is required'
							} else if (value < 5 * 60 * 1000) {
								error = `Increment should be at least 5 minutes`
							}
							callback(error);
						},
						trigger: 'validate'
					}
				],
				maxEventsPerWeek: [
					{
						validator: (rule, value, callback, source, options) => {
							let error;
							console.log("this.eventType.maxEventsPerWeek = ", this.eventType.maxEventsPerWeek)
							console.log("this.eventType.maxEventsPerDay = ", this.eventType.maxEventsPerDay)
							console.log("this.eventType.maxEventsPerWeek < this.eventType.maxEventsPerDay = ", this.eventType.maxEventsPerWeek < this.eventType.maxEventsPerDay)
							console.log("typeof maxEventsPerWeek = ", typeof this.eventType.maxEventsPerWeek)
							console.log("typeof maxEventsPerDay = ", typeof this.eventType.maxEventsPerDay)
							console.log("this.eventType.maxEventsPerWeek < this.eventType.maxEventsPerDay = ", this.eventType.maxEventsPerWeek < this.eventType.maxEventsPerDay)
							console.log("value = ", value)
							if (this.eventType.maxEventsPerWeek && this.eventType.maxEventsPerWeek < this.eventType.maxEventsPerDay) {
								error = `Max sessions per week can't be less than max sessions per day`
							}
							callback(error);
						},
						trigger: 'validate'
					}
				],
				minimumCancellationNotice: [
					{
						validator: (rule, value, callback, source, options) => {
							let error;
							if (value < 60 * 60 * 1000) {
								error = `Must be at least 1 hour`
							}
							callback(error);
						},
						trigger: 'validate'
					}
				]

			}
		};
	},
	created() {
		console.log("SchedulerGeneralSettings created111")
		this.teamAssignManager = new TeamAssignManager(this)
		this.sessionTypeHelper = new SessionTypeHelper(this)
		this.updateEventTypeDebouncer = new Debouncer(this._updateEventTypeInternal.bind(this), 1000)
		this.setupReminderOptions()

	},

	mounted() {
		if (this.validateOnEnter) {
			setTimeout(() => this.validateFormCustom(), 500)
		}
	},


	methods: {

		async onShowPaymentMethodsClicked() {
			let res = await this.submitFormInternal({
				skipEmitOnSaved: true,
				hideToast: true,
				validateFormErrorMessage: "Please fill in all the required fields before proceeding with the payment options"
			})
			if (res) {
				this.showPaymentMethodsOptions = true
			}
		},

		async tabBeforeLeave() {
			// return await yesNoDialog("Switch tab?", "You sure??", "Yes", "No", true)
		},

		setupReminderOptions() {
			let oneHour = 60 * 60 * 1000
			this.reminderOptions = [
				{label: 'hour(s)', value: oneHour},
				{label: 'day(s)', value: 24 * oneHour},
			]
			this.reminderOptionsDirections = [
				{label: 'before', value: -1},
				{label: 'after', value: 1},
			]
		},

		onLinkKeyDown(event) {
			// TODO add logic to automatically substitute incorrect characters as user is typing
			// like " "->"-", "A"->"a" etc.
		},
		onLinkChanged(props) {
			console.log("onLinkChanged")
			this.linkChanged = true
			this.valueChanged("session link", props)
		},

		async validateFormCustom(message = "Some required fields are not set.") {

			let [res1, res2] = await Promise.all([
				this.validateForm(),
				this.$refs.locationChooser.validateForm()
			])
			let isValid = res1 && res2
			if (res1 && !res2) {
				this.toastWarn(message)
			}
			return isValid
		},


		async submitFormInternal(options = {}) {
			let _ = this.$analyticManager.trackEvent("Save clicked", this.analyticsPropsMethod())
			let isValid = await this.validateFormCustom(options.validateFormErrorMessage)
			if (isValid) {
				this.eventType.needsSetup = false
				await this.updateEventType()
				if (!options.hideToast && !this.hideToast) this.toast("Updated successfully")
				if (!options.skipEmitOnSaved) {
					this.$emit("onSaved", this.eventType)
				}
			}
			return isValid
		},

		onAddEmailClicked() {
			let reminderTitle = `Email reminder ${this.eventType.emailReminders.length + 1}`
			let emailReminder = new EmailReminderItem("", "", reminderTitle)
			emailReminder._isPersonalizationShowing = true
			this.eventType.emailReminders.push(emailReminder)
		},

		clearFormValidationInternal() {
			this.clearFormValidation()
			this.$refs.locationChooser.clearFormValidation()
		},

		formatDataInMinutes(buffer) {
			return buffer / (60 * 1000)
		},

		formatDataOutMinutes(buffer) {
			return buffer * (60 * 1000)
		},

		formatDataInHours(buffer) {
			return buffer / (60 * 60 * 1000)
		},

		formatDataOutHours(buffer) {
			return buffer * (60 * 60 * 1000)
		},

		formatDataInDays(buffer) {
			return buffer / (24 * 60 * 60 * 1000)
		},

		formatDataOutDays(buffer) {
			return buffer * (24 * 60 * 60 * 1000)
		},

		formatInMaxEventsPerWeekOrDay(value) {
			return value ? value : ""
		},

		onReminderBaseValueChanged(reminder) {
			this.reminderOptions = this.reminderOptions.map(option => {
				if (option.label.endsWith('s')) {
					option.label = option.label.substring(0, option.label.length - 1);
				}
				if (reminder.trigger.shiftBaseAmount !== 1) {
					option.label = option.label + 's'
				}
				return option
			})
		},

		emailReminderDirectionChanged(reminder) {
			console.log("emailReminderDirectionChanged: direction = ", reminder.trigger.shiftDirection)
			let title = reminder.title
			if (reminder.trigger.isFollowup()) {
				title = title.replace("reminder", "follow up")
			} else {
				title = title.replace("follow up", "reminder")
			}
			reminder.title = title
			this.recalculateEmailRemindersExtraShift()
		},

		async setEventTypeNeedsSetup() {
			if (!this.eventType.needsSetup) {
				this.eventType.needsSetup = true
				await this.saveEventType()
			}
		},


		async onEmailReminderDeleteClicked(index) {
			let options = {
				itemName: "email"
			}
			if (index > 0 && await deleteConfirmDialog(options)) {
				this.eventType.emailReminders.splice(index, 1)
			}
		},

		onDurationChanged() {
			this.recalculateEmailRemindersExtraShift()
			this.valueChanged('Duration')
		},

		async valueChanged(title, props = {}) {
			this.$analyticManager.trackEvent("Value changed", {label: title, ...this.analyticsPropsMethod(), ...props})
			if (!props.skipSave) {
				await this.updateEventType()
			}
		},

		validateEmailReminder(rule, emailReminder, callback) {
			console.log("emailReminderValidator")
			let error
			let hasReminderWithSameTime = this.hasReminderWithSameTime(emailReminder)
			if (!emailReminder.subject && !emailReminder.body) {
				error = "Please feel in email subject and body or remove this email from the sequence."
				emailReminder._isPersonalizationShowing = true
			} else if (!emailReminder.subject) {
				error = "Please feel in email subject."
				emailReminder._isPersonalizationShowing = true
			} else if (!emailReminder.body) {
				error = "Please feel in email body."
				emailReminder._isPersonalizationShowing = true
			} else if (hasReminderWithSameTime) {
				error = "This email has the same send time as another email in this sequence. Please change the send time or remove this email."
			}
			callback(error)
		},

		recalculateEmailRemindersExtraShift() {
			for (let reminder of this.eventType.emailReminders) {
				if (reminder.trigger.isFollowup()) {
					reminder.trigger.extraShiftAmountMs = this.eventType.duration
				} else {
					reminder.trigger.extraShiftAmountMs = 0
				}
			}
		},

		hasReminderWithSameTime(emailReminder) {
			let reminderTriggerShift = emailReminder.trigger.getTriggerShift()
			for (let reminder of this.eventType.emailReminders) {
				if (reminder === emailReminder || (emailReminder.id && reminder.id === emailReminder.id)) {
					// We only check all reminders before this one.
					// As soon as we meet this one in the array, we stop.
					return false
				}

				if (reminderTriggerShift === reminder.trigger.getTriggerShift()) {
					return true
				}
			}
			console.log("hasReminderWithSameTime: nothing found")
			return false
		},

		openLinkClicked() {
			this.$analyticManager.trackEvent("Open scheduling link clicked", this.analyticsPropsMethod())
		},

		togglePersonalizationShow() {
			this.showEmailNotificationPersonalization = !this.showEmailNotificationPersonalization
			this.valueChanged("Personalization email show", {value: this.showEmailNotificationPersonalization})
		},

		async startIntegrationClicked() {
			await this.updateEventType()
		},

		async copyLink() {
			let _ = this.$analyticManager.trackEvent("Copy scheduling link clicked", this.analyticsPropsMethod())
			let eventFullUrlOptions = {}
			if(this.isTeamFeatureEnabled){
				let teamMember = await this.teamAssignManager.pickTeamMember({
					title: "Select a member to copy the link for",
					cancelTitle: "Copy general link",
				})
				if(teamMember){
					eventFullUrlOptions.teamMemberId = teamMember.id
				}
			}
			let link = this.getSessionFullUrlComputed(eventFullUrlOptions)
			try {
				await this.$copyText(link)
				this.toast("Link copied to clipboard.")
			} catch (error) {
				this.handleError(error)
			}
		},

		async loadPaymentIntegrations() {
			if (!this.paymentIntegrations) {
				this.paymentIntegrations = await this.handleAsync(this.$dataManager.getPaymentIntegrationsMain())
			}
		},

		// async loadSessionType() {
		// 	let promise = Promise.all([
		// 		this.$dataManager.apiGetEventType({sessionTypeId: this.eventTypeId, coachId: this.getCoachId()}),
		// 		this.$dataManager.getPaymentIntegrationsMain(),
		// 	])
		// 	let [eventType, paymentIntegrations] = await this.handleAsync(() => promise)
		//
		// 	this.eventType = eventType
		// 	this.displayNameInitial = eventType.displayName
		//
		// 	this.paymentIntegrations = paymentIntegrations
		// },

		async onDeleteClicked() {
			try {
				await this.$dataManager.deleteEventType(this.eventTypeId)
				this.onBackPressed()
			} catch (error) {
				this.handleError(error)
			}
		},

		onSaveIsSticky(res) {
			this.isSaveButtonSticked = res.sticked
			if (this.$refs.optionsMenu) {
				this.$refs.optionsMenu.showPopup(false)
			}
		},

		async updateEventType() {
			// this.updateEventTypeDebouncer.onChangeDebounced()
			await this._updateEventTypeInternal()
		},

		async _updateEventTypeInternal() {
			if (this.displayNameInitial !== this.eventType.displayName) {
				this.displayNameInitial = this.eventType.displayName
			}
			if (this.eventType.isEmailReminderEnabled) {
				this.eventType.emailReminder = this.emailReminderData
			}


			console.log("_updateEventTypeInternal")
			await this.saveEventType()
		},

		async saveEventType() {
			await this.handleAsyncNonBlocking(() => this.$dataManager.setEventType(this.eventType))
		},

		menuClicked() {
			let _ = this.$analyticManager.trackEvent("Menu clicked", this.analyticsPropsMethod())
		},

		async onMenuItemClicked(action) {
			console.log("Session type: onMenuItemClicked = ", action)
			let actionPromise = Promise.resolve()
			let _ = this.$analyticManager.trackEvent("Menu item clicked", {action, ...this.analyticsPropsMethod()})

			switch (action) {
				case MenuAction.COPY:
					actionPromise = this.copySession()
					break
				case MenuAction.DELETE:
					actionPromise = this.deleteSession()
					break
			}

			return this.handleAsync(() => actionPromise)
		},

		async copySession() {
			let isValid = await this.validateFormCustom()
			if (isValid) {
				this.eventType.needsSetup = false
				await this.updateEventType()
				await this.sessionTypeHelper.copySessionType(this.eventType)
				this.toast("Session type was copied successfully")
				await this.go(this.backRouteName)
			}
		},

		async deleteSession() {
			let isDeleted = await this.sessionTypeHelper.deleteSessionType(this.eventType)
			if (isDeleted) {
				this.toast("Session type was deleted successfully")
				await this.go(this.backRouteName)
			}
		},

		analyticsPropsInternal() {
			return {
				category: "Session type settings",
				session_type_id: this.eventType.id
			}
		},

		getSessionFullUrlComputed(options = {}) {
			return this.sessionFullUrl(this.eventType, options)
		},



	},
	computed: {

		emailReminderData: {
			get: function () {
				return this.eventType.emailReminder || new EmailReminderItem()
			},
			set: function (reminder) {
				this.eventType.emailReminder = reminder
			}
		},

		reminderDefaultSubject() {
			return defaultReminderSubject
		},
		reminderDefaultBody() {
			return defaultReminderBody
		},


		sessionFullUrlComputed() {
			return this.sessionFullUrl(this.eventType)
		},

		isSetupCompleted() {
			return this.userProfile.schedulerSettings.isSetupCompleted;
		},

		sessionText() {
			return this.eventType.maxEventsPerDay === 1 ? "session" : "sessions"
		},

		savingNotification() {
			return this.$refs.savingNotification
		},

		billingSectionUrl() {
			return this.resolvePathByRouteName("billingRoot")
		},


		menuItems() {
			let isTeam = this.userProfile.featuresUsing.team
			return [
				MenuItem.createDuplicateItem(),
				isTeam ? MenuItem.createLinkItem("Share with team") : null,
				MenuItem.createDeleteItem(),
			]
		},

		hasPaymentIntegration() {
			return this.userProfile.integrationsList.hasPaymentIntegration()
		},

		isVerticalComputed() {
			return this.isVertical || isMobileScreen()
		},
	}


}
</script>

<!--<style src="../Scheduler.scss" lang="scss" scoped/>-->



<style lang="scss">

.event-settings-root {
	.sticked {
		background: white;
		//border-bottom: 1px solid;
	}

	.reminder-error-padding {
		.el-form-item__error {
			padding-top: 15px;
			padding-left: 170px;
		}
	}
}

/*.error-padding .el-form-item__error {*/
/*	padding-left: 150px !important;*/
/*}*/

/*.error-padding__10 .el-form-item__error {*/
/*	padding-left: 10px !important;*/
/*}*/

</style>
